import React from 'react'
import {AiOutlineCopyrightCircle} from 'react-icons/ai'

const Footer =()=>{
    return (<>
       {/* <hr /> */}
      <section id="footer">
        <p><AiOutlineCopyrightCircle/> 2022 Prince Raj. All right reserved | Term and Condition </p>
      </section>
    </>);
}

export default Footer;